const getTextWidth = (text: string) => {
  if (!text) return 20;
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  context!.font = getComputedStyle(document.body).font;
  const isUpperCase = text === text.toUpperCase();
  const width = context!.measureText(text).width;
  return isUpperCase ? width + 5 : width;
};

export default getTextWidth;
